import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { getAdditionalProps } from 'apps/studio/components/settings/inputs'
import { IconTooltip } from 'apps/studio/components/shared/IconTooltip'

export const SettingsToggle = ({
  property,
  label,
  id,
  data,
  choices = [
    { value: true, previousValue: false },
    { value: false, previousValue: true },
  ],
  update,
  tooltipContent,
  isDisabled = () => false,
  dynamicChoices = () => false,
  DisabledModalAction,
}) => {
  const dispatch = useDispatch()
  const [showDisabledModal, setShowDisabledModal] = useState(false)
  let { [property]: activeValue = false } = data
  const toggleOptions = dynamicChoices(data) || choices
  const normalizedActiveValue =
    activeValue === null || activeValue === undefined ? false : activeValue
  const { value, additionalProps = {} } =
    toggleOptions.find(
      ({ previousValue }) => previousValue == normalizedActiveValue
    ) || {}
  const checked = activeValue === toggleOptions[0].value
  const disabled = isDisabled(data)

  const onChange = () => dispatch(
    update({ [property]: value, ...getAdditionalProps(additionalProps) })
  )

  const onClick = () => {
    if (disabled) {
      setShowDisabledModal(true)
    }
  }

  const onClose = e => {
    e?.stopPropagation()
    setShowDisabledModal(false)
  }

  return (
    <div
      className={`gcds--toggle -foundry--toggles -toggle--modern ${
        disabled ? 'disabled' : ''
      }`}
    >
      {label && (
        <label
          className="toggle--label"
          htmlFor={id}
          aria-label={`${property} toggle`}
        >
          <span className="label--text">{label}</span>
          {tooltipContent && (
            <IconTooltip
              tooltipContent={tooltipContent}
              width="medium"
              position="left"
            />
          )}
        </label>
      )}
      <div className="toggle--element" onClick={onClick}>
        <input
          className="toggle--input"
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      {showDisabledModal && DisabledModalAction && (
        <DisabledModalAction onClose={onClose}/>
      )}
    </div>
  )
}
